import { useCallback } from 'react';
import { useTypedMutation } from '../../useTypedMutation';
import { CancelExportDocument } from './utils/__generated__/CancelExport.graphql';
import { RetryExportDocument } from './utils/__generated__/RetryExport.graphql';

//! Note: It works only for batch exports
export const useExportsActions = () => {
  const { set: cancelExport } = useTypedMutation(CancelExportDocument);
  const { set: restartExport } = useTypedMutation(RetryExportDocument);

  const cancelExportHandler = useCallback(
    (executionId: string) => {
      cancelExport({ variables: { executionId } });
    },
    [cancelExport]
  );

  const restartExportHandler = useCallback(
    (executionId: string) => {
      restartExport({ variables: { executionId } });
    },
    [restartExport]
  );

  return { cancelExport: cancelExportHandler, restartExport: restartExportHandler };
};
